<template>
    <div>
        <b-button variant="default" @click="handleUpgradeDowngradeCancelClick" v-if="!isCurrent">
            <font-awesome-icon v-if="isCancel" :icon="['fas', 'xmark']"></font-awesome-icon>
            <font-awesome-icon v-if="isUpgrade" :icon="['fas', 'arrow-up']"></font-awesome-icon>
            <font-awesome-icon v-if="isDowngrade" :icon="['fas', 'arrow-down']"></font-awesome-icon> {{ buttonLabel }}
        </b-button>
    </div>
</template>

<script>
    import capitalize from 'lodash/capitalize';

    export default {
        computed: {
            buttonLabel() {
                return capitalize(this.params.data.upgrade_downgrade_mode);
            },
            isUpgrade() {
                return this.params.data.upgrade_downgrade_mode == 'UPGRADE';
            },
            isDowngrade() {
                return this.params.data.upgrade_downgrade_mode == 'DOWNGRADE';
            },
            isCancel() {
                return this.params.data.upgrade_downgrade_mode == 'CANCEL';
            },
            isCurrent() {
                return this.params.data.package_status === 'Current package';
            },
        },
        methods: {
            async handleUpgradeDowngradeCancelClick() {
                if (this.isCancel) {
                    this.params.onCancel(this.params.data.id);
                } else {
                    this.params.onChange(this.params.data.id);
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    :deep(.btn) {
        width: 130px !important;
        text-transform: capitalize !important;
        font-size: 14px !important;
    }
</style>
